// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/layoutEdit/layoutEditCtrl.js#1 $
'use strict';

angular.module('tcApp')
.controller('LayoutEditCtrl', function($scope, $log, $sce, $timeout, $location, $mdPanel, $window,
										$document, $position, $route,
										SystemRouter, GlobalService, tcConstants, ComponentCache, ToastService, OverlayService,
										ElementStateService) {
	// Data to display
	if (!$scope.data) $scope.data = {};
	if ($scope.data.error) $log.error($scope.data);
	GlobalService.updateBannerData({});
	$scope.globalStrings = GlobalService.getGlobalStrings();
	
	$scope.viewModel = {
		prettyData: '',
		showToolbox: true,
		showActionMenu: false,
		showHeaderBar: false,
		showButtonBar: false,
		showHover: false,
		showData: false,
		useOldOptions: false,
		panelOpening: false,
		advancedExpressions: false,
		optionsPanelMode: null,
		optionsPanelItem: null,
		undoStackElements: ['layout','list','actionMenu','buttonBar','headerBar'],
		undoStack: [],
		undoStackIndex: -1,
		cacheUserName: GlobalService.logonData.cacheUserName,
		siteCode: GlobalService.logonData.siteCode,
		isReadOnly: false,
		hideError: false,
		selectedToolboxItem: 0,
		toolboxItems: {
			items: [],
			tableItems: []
		},
		toggles: {
			items: true,
			tableItems: true,
			layoutElements: true,
			listElements: true,
			headerBar: true,
			listSection: true,
			buttonBar: true
		},
		optionLookup: {
			BackgroundImage: {
				id: 'BackgroundImage',
				value: ''
			}
		}
	};

	// Populates the caption array and sorts it alphabetically
	var getCaptionArray = function() {
		var captionArray = [];
		angular.forEach($scope.data.translations, function(value, key) {
			if (key.indexOf('ResponsiveDisplay-') === 0) return;
			captionArray.push({code: key,desc: value});
		});
		captionArray.sort(function(a, b) {
			return a.desc.toString().localeCompare(b.desc);
		});
		return captionArray;
	};
	
	$scope.viewModel.captionArray = getCaptionArray();
	
	// Get the selected context if Layout Editor is invoked in context
	var getSelectedContext = function() {
		var selectedContext = {
			id: (angular.isDefined($scope.data.component) ? $scope.data.component.id : ''),
			desc: ''
		};
		if ((angular.isDefined($scope.data.preference)) && (angular.isDefined($scope.data.preference.context))) {
			selectedContext.id = $scope.data.preference.context;
			selectedContext.desc = $scope.data.preference.contextDescription;
		}
		return selectedContext;
	};
	$scope.viewModel.selectedContext = getSelectedContext();
	
	// Display different translations based on context
	$scope.updateTranslations = function(componentId, selectedContextId, selectedContextDesc) {
		SystemRouter.fetchLayoutTranslations(componentId + selectedContextId)
		.then(function(response) {
			$scope.data.translations = response.data.translations;
			$scope.viewModel.selectedContext.id = selectedContextId;
			$scope.viewModel.selectedContext.desc = selectedContextDesc;
			if (selectedContextId !== '') {
				ElementStateService.set('tcLayoutEditTranslationsFor', [selectedContextId, selectedContextDesc]);
			} else {
				ElementStateService.removeKey('tcLayoutEditTranslationsFor');
			}
		});
	};
	
	// Load the previously selected context from the 'Translation for...' menu
	var loadTranslations = function() {
		var componentId = (angular.isDefined($scope.data.component) ? $scope.data.component.id : '');
		if (componentId === '') return;
		var contextCode = ElementStateService.get('tcLayoutEditTranslationsFor');
		if ((angular.isDefined(contextCode)) && (contextCode[0] !== '')) {
			$scope.updateTranslations(componentId, contextCode[0], (contextCode[1] || ''));
		}
	};
	loadTranslations();
	
	// Populates the 'optionLookup' object for an item (Needed for item option lookups)
	var populateOptionLookup = function(option, itemName, itemRef) {
		if (angular.isUndefined(option.lookup)) return;
		
		if (angular.isUndefined($scope.viewModel.optionLookup[itemName])) {
			$scope.viewModel.optionLookup[itemName] = {};
		}
		$scope.viewModel.optionLookup[itemName][option.name] = {
			id: option.name,
			value: ((angular.isDefined(itemRef) && itemRef[option.name]) ? itemRef[option.name] : ''),
			lookupProperties: option.lookupParameters
		};
	};
	
	// For all items & table items, populate the 'optionLookup' objects needed for item option lookups
	var populateOptionLookups = function() {
		if (angular.isUndefined($scope.data.component)) return;
		if (angular.isDefined($scope.data.component.items)) {
			angular.forEach($scope.data.component.items, function(item) {
				var itemRef;
				if ((angular.isDefined($scope.data.itemRefList))
					&& (angular.isDefined($scope.data.itemRefList.itemRefs))) {
					itemRef = $scope.data.itemRefList.itemRefs[item.name];
				}
				angular.forEach($scope.data.itemRefOptions, function(itemRefOption) {
					populateOptionLookup(itemRefOption, item.name, itemRef);
				});
			});
		}
		if (angular.isDefined($scope.data.component.tableItems)) {
			angular.forEach($scope.data.component.tableItems, function(tableItem) {
				var tableItemRef;
				if ((angular.isDefined($scope.data.itemRefList))
					&& (angular.isDefined($scope.data.itemRefList.tableItemRefs))) {
					tableItemRef = $scope.data.itemRefList.tableItemRefs[tableItem.name];
				}
				angular.forEach($scope.data.tableItemRefOptions, function(tableItemRefOption) {
					populateOptionLookup(tableItemRefOption, tableItem.name, tableItemRef);
				});
			});
		}
	};
	populateOptionLookups();
	
	if (angular.isDefined($scope.data.model)) {
		$scope.viewModel.isReadOnly = !$scope.data.model.isEditable;
	}
	$scope.state = {};
	$scope.state.selected = {};

	// Determine whether to show header & button bar
	if (($scope.data.component) && ($scope.data.component.items)) {
		angular.forEach($scope.data.component.items, function(item) {
			if (['A','B'].indexOf(item.displayType) !== -1) {
				$scope.viewModel.showButtonBar = true;
			}
			if (['A','B','C'].indexOf(item.displayType) !== -1) {
				$scope.viewModel.showHeaderBar = true;
			}
		});
		if (($scope.viewModel.showButtonBar) && (!$scope.data.buttonBar)) $scope.data.buttonBar = {'buttons': []};
		if (($scope.viewModel.showHeaderBar) && (!$scope.data.headerBar)) $scope.data.headerBar = {'items': []};
	}
	
	var keyDownHandler = function($event) {
		if ($event.keyCode === tcConstants.KEY_CODE.DELETE) {
			// Allow del for remove
			$scope.remove();
			$scope.$digest(); //eslint-disable-line
		} else if ((($event.ctrlKey) || (($event.metaKey) && (!$event.shiftKey)))
			&& ($event.keyCode === tcConstants.KEY_CODE.Z)) {
			$event.preventDefault();
			// Allow ctrl-Z (meta-Z) undo
			$scope.undo();
			$scope.$digest(); //eslint-disable-line
		} else if ((($event.ctrlKey) && ($event.keyCode === tcConstants.KEY_CODE.Y))
			|| ((($event.metaKey) && ($event.shiftKey) && ($event.keyCode === tcConstants.KEY_CODE.Z)))) {
			// Allow ctrl-Y (meta-shift-Z) for redo
			$event.preventDefault();
			$scope.redo();
			$scope.$digest(); //eslint-disable-line
		}
	};
	$document.on('keydown', keyDownHandler);
	$scope.$on('$destroy', function() {
		$document.off('keydown', keyDownHandler);
	});

	// Define all possible layout elements
	$scope.layoutElements = {
		section: [
			{
				blocks: [
				{rows: [{itemRefs: []}]}
				]
			}
		],
		block: [
			{rows: [{itemRefs: []}]}
		],
		row: [
			{itemRefs: []}
		],
		column: [
			{columnRows: [{tableitemRefs: []}]}
		],
		columnRow: [
			{tableitemRefs: []}
		]
	};

	// Define all possible custom elements
	$scope.customElements = {
		text: [{
			FreeTextMultiLine: 'Enter Text',
			Type: 'Text'
		}],
		caption: [{
			Caption: '',
			Type: 'Caption'
		}],
		link: [{
			FreeText: 'Enter Link Text',
			Type: 'Link'
		}],
		expression: [{
			Type: 'Expression'
		}],
	};
	
	$scope.saveLayout = function() {
		var modelJson = angular.toJson($scope.data);
		if (angular.isUndefined($scope.data.model)) return;
		if ($scope.data.model.ownerCode === 'SYS') {
			if (($scope.data.sourceControl.invalidUser) || (!$scope.data.sourceControl.isEditable)) return;
		}
		
		SystemRouter.saveLayout($scope.data.model.className, modelJson)
		.then(function(responseData) {
			var message = (responseData.data.error ? 'Error saving layout!' : 'Layout saved!');
			if (!responseData.data.error) {
				// Always remove the non-context layout template
				GlobalService.removeCachedLayoutTemplate($scope.data.component.name);
				ComponentCache.removeAll();
				$route.reload();
			} else {
				message += '<BR><BR>' + responseData.data.error.displayString;
				$log.error('Error saving layout!\n\n', responseData.data.error.displayString);
			}
			ToastService.show({
				message: message,
				type: (responseData.data.error ? 'error' : '')
			});
		}, function(err) {
			$log.error(err);
		});
	};
	
	// Executes a source control action and either reloads or outputs error data
	$scope.sourceControlAction = function(action) {
		var errorText = ((action === 'checkOut') ? 'Error checking out!'
		: (action === 'undoCheckOut') ? 'Error on undo check out!'
		: (action === 'getLatest') ? 'Error getting latest!'
		: (action === 'addToSourceControl') ? 'Error adding to source control!'
		: 'Error on source control action:' + action);
		var successText = ((action === 'checkOut') ? 'Checked out'
		: (action === 'undoCheckOut') ? 'Checkout undone'
		: (action === 'getLatest') ? 'Got latest from source control'
		: (action === 'addToSourceControl') ? 'Added to source control'
		: 'Success!');
		
		var modelJson;
		// Also save the layout, so changes are not lost when adding to source control
		if (action === 'addToSourceControl') modelJson = angular.toJson($scope.data);
		
		SystemRouter.sourceControlAction(action, $scope.data.model.className, modelJson)
		.then(function(responseData) {
			var message = (responseData.data.error ? errorText : successText);
			if (!responseData.data.error) {
				GlobalService.removeCachedLayoutTemplate($scope.data.component.name);
				ComponentCache.removeAll();					
				if (responseData.data.closeLayoutRedirect) {
					$location.path(responseData.data.closeLayoutRedirect);			
				} else {
					$route.reload();
				}
			} else {
				$log.error(responseData.data.error);
			}
			ToastService.show({
				message: message,
				type: (responseData.data.error ? 'error' : '')
			});
		}, function(err) {
			$log.error(err);
		});
	};
		
	// Runs layout converter (or questionnaire model generator) and overrides current model, then reloads layout editor
	$scope.importLayout = function(context, questionnaireId) {
		if (angular.isUndefined($scope.data.model)) return;		
		if ($scope.data.model.ownerCode === 'SYS') {
			if (($scope.data.sourceControl.invalidUser) || (!$scope.data.sourceControl.isEditable)) return;
		}
		if (angular.isUndefined(context)) context = '';
		if ($window.confirm('Warning: This will override the current layout and cannot be undone, continue?')) {
			SystemRouter.importLayout($scope.data.component.name, $scope.data.model.className, context, questionnaireId)
			.then(function(responseData) {
				var message = (responseData.data.error ? 'Error importing layout!' : 'Layout imported!');
				if (!responseData.data.error) {
					GlobalService.removeCachedLayoutTemplate($scope.data.component.name);
					ComponentCache.removeAll();
					$route.reload();
				} else {
					$log.error(responseData.data.error);
				}
				ToastService.show({
					message: message,
					type: (responseData.data.error ? 'error' : '')
				});
			}, function(err) {
				$log.error(err);
			});
		}
	};
	
	$scope.regenerateQuestionnaireModel = function(questionnaireId) {
		// Only allow this for unnamed system model
		if ((angular.isUndefined($scope.data.model)) || ($scope.data.model.ownerCode !== 'SYS') || ($scope.data.model.name)
			|| ($scope.data.sourceControl.invalidUser) || (!$scope.data.sourceControl.isEditable)) {
			return;
		}
		$scope.importLayout('', questionnaireId);
	};
	
	$scope.navBack = function() {
		$location.url('/CloseReload');
	};

	// Traverses nested blocks to find an item
	var isInBlock = function(block, item) {
		var itemFound = false;
		if ((item.displayType === 'FPROOM') && (('Room' + block.room) === item.name)) {
			return true;
		}
		angular.forEach(block.rows, function(row) {
			if (itemFound) return;
			if (angular.isDefined(row.blocks) && (row.blocks.length)) {
				angular.forEach(row.blocks, function(nestedBlock) {
					if (itemFound) return;
					itemFound = isInBlock(nestedBlock, item);
				});
			} else {
				angular.forEach(row.itemRefs, function(itemRef) {
					if (itemFound) return;
					if (itemRef.name === item.name) itemFound = true;
				});
			}
		});
		return itemFound;
	};

	$scope.isShownInToolbox = function(item, isTableItem) {
		// Filter items by search box
		if (($scope.viewModel.searchToolbox) && ($scope.viewModel.searchToolbox != '')) {
			var searchString = $scope.viewModel.searchToolbox.toUpperCase();
			var nameString = item.name.toUpperCase();
			var captionString = '';
			if ($scope.data.translations[item.name]) {
				captionString = $scope.data.translations[item.name].toUpperCase();
			}
			var typeString = item.displayType.toUpperCase();
			if ((nameString.indexOf(searchString) == -1) &&
			(captionString.indexOf(searchString) == -1) &&
			(typeString.indexOf(searchString) == -1)) return false;
		}
		var itemFound = false;
		if ($scope.viewModel.showActionMenu) {
			if ($scope.data.actionMenu) {
				if (['S','IP','CX','SVG'].indexOf(item.displayType) !== -1) {
					// These item types are not supported in the action menu
					return false;
				}
				if ((item.displayType === 'A') || (item.displayType === 'B')) {
					// Can't use array.find() because IE11 things ...
					angular.forEach($scope.data.actionMenu.links, function(actionMenuLink) {
						if (itemFound) return;
						if (actionMenuLink.name === item.name) itemFound = true;
					});
					if (itemFound) return false;
				} else {
					// Hide the item in the toolbox if it is configured in both the headers & items
					var isInHeaders = false;
					angular.forEach($scope.data.actionMenu.headers, function(actionMenuHeader) {
						if (actionMenuHeader.name === item.name) isInHeaders = true;
					});
					var isInItems = false;
					angular.forEach($scope.data.actionMenu.items, function(actionMenuItem) {
						if (actionMenuItem.name === item.name) isInItems = true;
					});
					if (isInHeaders && isInItems) return false;
				}
			}
		} else {
			if (isTableItem) {
				// Find an item in the list structure
				if (($scope.data.list) && ($scope.data.list.columns)) {
					angular.forEach($scope.data.list.columns, function(column) {
						if (itemFound) return;
						
						if (angular.isDefined(column.dynamicColumn)) {
							if (column.dynamicColumn === item.name) itemFound = true;
						} else {
							angular.forEach(column.columnRows, function(columnRow) {
								if (itemFound) return;
								angular.forEach(columnRow.tableItemRefs, function(tableItemRef) {
									if (itemFound) return;
									if (tableItemRef.name === item.name) itemFound = true;
								});
							});
						}
					});
				}
				if (itemFound) return false;
			} else {
				// For data setup layouts, allow items to be configured in multiple sections
				if (angular.isDefined($scope.data.model) && $scope.data.model.isDataSetup) return true;
				// Find an item in the layout structure
				if (($scope.data.layout) && ($scope.data.layout.sections)) {
					angular.forEach($scope.data.layout.sections, function(section) {
						if (itemFound) return;
						angular.forEach(section.blocks, function(block) {
							if (itemFound) return;
							itemFound = isInBlock(block, item);
						});
					});
				}
				if (itemFound) return false;
				
				// Find an item in the button bar structure
				if (($scope.data.buttonBar) && ($scope.data.buttonBar.buttons)) {
					angular.forEach($scope.data.buttonBar.buttons, function(button) {
						if (itemFound) return;
						if (button.name === item.name) itemFound = true;
					});
				}
				if (itemFound) return false;
				
				// Find an item in the header bar structure
				if (($scope.data.headerBar) && ($scope.data.headerBar.items)) {
					angular.forEach($scope.data.headerBar.items, function(headerBarItem) {
						if (itemFound) return;
						if (headerBarItem.name === item.name) itemFound = true;
					});
				}
				if (itemFound) return false;
			}
		}
		return true;
	};

	$scope.getTableItemType = function(tableItem) {
		if ($scope.viewModel.showActionMenu) {
			if ((tableItem.displayType === 'A') || (tableItem.displayType === 'B')) {
				return 'actionLink';
			} else {
				return 'actionItem';
			}
		}
		return 'column';
	};

	// Sets the relevant items into the toolboxItems object.
	// Must be called whenever toolbox items could change
	// Better performance than running function for every item in the toolbox
	$scope.refreshToolboxItems = function() {
		if (angular.isUndefined($scope.data.component)) return;
		
		$scope.viewModel.toolboxItems.items = [];
		if (!$scope.viewModel.showActionMenu) {
			angular.forEach($scope.data.component.items, function(item) {
				if (!$scope.isShownInToolbox(item, false)) return;

				var newItem = angular.copy(item);
				$scope.viewModel.toolboxItems.items.push(newItem);
			});
		}
		$scope.viewModel.toolboxItems.tableItems = [];
		angular.forEach($scope.data.component.tableItems, function(tableItem) {
			if (!$scope.isShownInToolbox(tableItem, true)) return;
			
			var newItem = angular.copy(tableItem);
			newItem.tableItemType = $scope.getTableItemType(newItem);
			$scope.viewModel.toolboxItems.tableItems.push(newItem);
		});
	};
	
	$scope.refreshToolboxItems();
	
	$scope.applySearch = function() {
		$scope.clearSelected();
		$scope.refreshToolboxItems();
		$scope.highlightLayoutItems();
	};
	
	$scope.remove = function() {
		if ($scope.viewModel.isReadOnly) return;
		if (!$scope.state.selected.array) return;
		if ($scope.state.selected.isToolbox) return;
		
		var itemType = $scope.state.selected.type;
		var arrayItem = $scope.state.selected.array[$scope.state.selected.index];
		if (arrayItem && ((angular.isDefined(arrayItem.tag) && (arrayItem.tag !== ''))
						|| (angular.isDefined(arrayItem.Tag) && (arrayItem.Tag !== '')))) {
			var warningMessage = 'Element has the Tag option populated.\n'
								+ 'Removing this element may adversely affect functionality in the component script.\n'
								+ 'Continue?';
			if (!$window.confirm(warningMessage)) {
				return;
			}
		}
		if ((arrayItem) && (itemType == 'section') && (arrayItem.list)) {
			delete $scope.data.list;
		}
		$scope.state.selected.array.splice($scope.state.selected.index, 1);
		$scope.clearSelected();
		if (['columnRow','tableItemRef'].indexOf(itemType) !== -1) cleanEmptyColumns();
		$scope.addToUndoStack();
		$scope.refreshToolboxItems();
	};
	
	$scope.toggleSort = function($event, tableItem) {
		if ($scope.viewModel.isReadOnly) return;
		
		if (angular.isUndefined($scope.data.itemRefList.tableItemRefs[tableItem.name])) {
			$scope.data.itemRefList.tableItemRefs[tableItem.name] = {};
		}
		var tableItemRef = $scope.data.itemRefList.tableItemRefs[tableItem.name];
		tableItemRef.IsSortable = !tableItemRef.IsSortable;
		$scope.clearSelected();
		$event.stopPropagation();
	};
	
	var cleanEmptyColumns = function() {
		var tableItemCount;
		// Clean up empty columns after moving the last table item
		angular.forEach($scope.data.list.columns, function(column, columnIndex, columns) {
			tableItemCount = 0;
			if (angular.isDefined(column.dynamicColumn)) return;
			
			angular.forEach(column.columnRows, function(columnRow) {
				if ((columnRow) && (columnRow.tableItemRefs)) {
					tableItemCount += columnRow.tableItemRefs.length;
				}
			});
			if (tableItemCount == 0) columns.splice(columnIndex, 1);
		});
	};
	
	$scope.afterDrop = function(dropType, isToolbox) {
		if ((!isToolbox) && (['columnRow','tableItemRef'].indexOf(dropType) !== -1)) {
			cleanEmptyColumns();
		}
		$scope.addToUndoStack();
		$scope.refreshToolboxItems();
		$scope.highlightLayoutItems();
		$scope.viewModel.showHover = false;
	};
	
	// Logic that allows supressing the 'tc-drop' icon on an element
	$scope.allowDrop = function(block) {
		if ((angular.isUndefined(block.roomQuery))
			|| (angular.isUndefined(($scope.state)))
			|| (angular.isUndefined($scope.state.selected))) {
			return true;
		}
		var selectedItem = null;
		if ($scope.state.selected.array) {
			selectedItem = $scope.state.selected.array[$scope.state.selected.index];
		}
		if (!selectedItem) return true;
		
		// Prevent moving beds/resources into query-type rooms
		if ((['FPBED','FPRESOURCE'].indexOf(selectedItem.displayType) !== -1)
			|| (angular.isDefined(selectedItem.itemRefs))) {
			if (block.roomQuery !== '') return false;
		}
		return true;
	};
	
	$scope.allowSelect = function(item) {
		if (item.isLocked) return false;
		return true;
	};

	$scope.toggleData = function() {
		$scope.clearSelected();
		if (!$scope.viewModel.showData) {
			$scope.viewModel.prettyData = $sce.trustAsHtml(
			$scope.syntaxHighlight(angular.toJson($scope.data, true))
			);
		}
		$scope.viewModel.showData = !$scope.viewModel.showData;
	};
	
	$scope.toggleOldOptions = function() {
		$scope.viewModel.useOldOptions = !$scope.viewModel.useOldOptions;
	};
	
	$scope.toggleAdvancedExpressions = function() {
		$scope.viewModel.advancedExpressions = !$scope.viewModel.advancedExpressions;
	};

	$scope.toggleActionMenu = function() {
		$scope.clearSelected();
		$scope.viewModel.showActionMenu = !$scope.viewModel.showActionMenu;
		if (($scope.viewModel.showActionMenu) && (!$scope.data.actionMenu)) {
			$scope.data.actionMenu = {'headers': [], 'links': [],'items': []};
		}
		$scope.refreshToolboxItems();
	};

	$scope.toggleToolbox = function() {
		$scope.viewModel.showToolbox = !$scope.viewModel.showToolbox;
	};

	$scope.toggleOptionsHover = function($event) {
		if ($scope.viewModel.panelOpening) return;
		if (($scope.state.selected.array) && (!$scope.state.selected.isToolbox)) {
			var hoverDiv = angular.element($window.document.querySelector('.layoutEditOptionsHover'));
			if (($event) && (hoverDiv)) {
				var position = $position.offset(angular.element($event.target));
				position.top = (position.top - 28);
				hoverDiv.css({'left': position.left + 'px','top': position.top + 'px'});
			}
			
			$scope.viewModel.showHover = true;
		} else {
			$scope.viewModel.showHover = false;
		}
	};

	var layoutEditOptionsCtrl = function(mdPanelRef, $scope, $log, data, viewModel) {
		$scope.data = data;
		$scope.viewModel = viewModel;
		
		// Custom implementation to gather the lookup properties, because lookup is being used outside of tc-component
		$scope.getLookupParams = function(item) {
			if (angular.isUndefined(item.lookupProperties)) {
				return {P1: item.value};
			}
			var lookupParams = {};
			var lookupProperties = item.lookupProperties.split(',');
			var paramCount = 1;
			lookupProperties.forEach(function(lookupProperty) {  //eslint-disable-line
				if (lookupProperty === item.id) {
					lookupParams['P' + paramCount] = item.value;
				} else if (lookupProperty[0] === '\'') {
					lookupParams['P' + paramCount] = lookupProperty.replace(/['"]/g, '');
				} else {
					lookupParams['P' + paramCount] = 
					$scope.viewModel.optionLookup[$scope.viewModel.optionsPanelItem.name][lookupProperty].value;
				}
				paramCount++;
			});
			return lookupParams;
		};
		
		// Sets a value from the lookup 
		$scope.setLookupValue = function(rowData, dataItem) {
			var optionsPanelItemName = $scope.viewModel.optionsPanelItem.name;
			var rowDataId = rowData.split('^')[2];
			var rowDataDesc = rowData.split('^')[0];
			if (!rowDataId) rowDataId = rowDataDesc;
			
			if ($scope.viewModel.optionsPanelMode === 'block') {
				var camelCaseId = (dataItem.id.substr(0, 1).toLowerCase() + dataItem.id.substr(1));
				$scope.viewModel.optionsPanelItem[camelCaseId] = rowDataId;
				$scope.viewModel.optionsPanelItem[camelCaseId + 'Desc'] = rowDataDesc;
			} else if ($scope.viewModel.optionsPanelMode === 'tableItemRef') {
				if (angular.isUndefined(data.itemRefList)) data.itemRefList = {};
				if (angular.isUndefined(data.itemRefList.tableItemRefs)) data.itemRefList.tableItemRefs = {};
				if (angular.isUndefined(data.itemRefList.tableItemRefs[optionsPanelItemName])) {
					data.itemRefList.tableItemRefs[optionsPanelItemName] = {};
				}
				data.itemRefList.tableItemRefs[optionsPanelItemName][dataItem.id] = rowDataId;
			} else {
				if (angular.isUndefined(data.itemRefList)) data.itemRefList = {};
				if (angular.isUndefined(data.itemRefList.itemRefs)) data.itemRefList.itemRefs = {};
				if (angular.isUndefined(data.itemRefList.itemRefs[optionsPanelItemName])) {
					data.itemRefList.itemRefs[optionsPanelItemName] = {};
				}
				data.itemRefList.itemRefs[optionsPanelItemName][dataItem.id] = rowDataId;
			}
			dataItem.lookupValueSelected = true;
		};
		
		$scope.lookupChangeHandler = function(dataItem, handleValueChangeFunction) {
			dataItem.lookupValueSelected = false;
			handleValueChangeFunction();
		};
		
		$scope.optionChangeHandler = function(option) {
			if ((option.name === 'ListDisableSelectMode') && (option.value)) {
				angular.forEach($scope.data.componentOptions, function(compOption) {
					if (compOption.name === 'ListDefaultSelectMode') compOption.value = false;
				});
			} else if ((option.name === 'ListDefaultSelectMode') && (option.value)) {
				angular.forEach($scope.data.componentOptions, function(compOption) {
					if (compOption.name === 'ListDisableSelectMode') compOption.value = false;
				});
			}
		};
		
		// Click handler for checkbox item options - as per componentCtrl
		$scope.labelClickHandler = function($event, itemId) {
			$event.stopPropagation();
			$timeout(function() {
				var item = $window.document.getElementById(itemId);
				if (item) {
					angular.element(item).triggerHandler('click');
					item.focus();
				}
			}, 0);
		};
	};
	
	$scope.openOptionsPanel = function($event, optionsPanelMode, optionsPanelItem) {
		if ($scope.viewModel.panelOpening) return;
		$scope.clearSelected();
		if (optionsPanelMode.indexOf('row') === 0) optionsPanelMode = 'row';
		if (optionsPanelMode.indexOf('block') === 0) optionsPanelMode = 'block';
		if ((optionsPanelMode === 'actionItem') || (optionsPanelMode === 'actionLink')) optionsPanelMode = 'tableItemRef';
		
		$scope.viewModel.optionsPanelMode = optionsPanelMode;
		$scope.viewModel.optionsPanelItem = optionsPanelItem;
		if (!$scope.viewModel.useOldOptions) {
			openNewOptionsPanel($event, optionsPanelMode, optionsPanelItem);
			$event.stopPropagation();
			return;
		}
		if (optionsPanelMode === 'block') {
			$scope.viewModel.optionLookup['BackgroundImage'].value = optionsPanelItem.backgroundImageDesc;
		}
		
		var panelPosition = $mdPanel.newPanelPosition().absolute().center();
		var panelConfig = {
			controller: layoutEditOptionsCtrl,
			controllerAs: 'ctrl',
			bindToController: false,
			position: panelPosition,
			targetEvent: $event,
			templateUrl: 'template/layoutEdit/optionsPanel/optionsPanel.html',
			clickOutsideToClose: true,
			escapeToClose: true,
			focusOnOpen: true,
			trapFocus: true,
			hasBackdrop: true,
			locals: {
				data: $scope.data,
				viewModel: $scope.viewModel
			},
			onRemoving: function() {
				if (optionsPanelMode === 'block') {
					if ($scope.viewModel.optionLookup['BackgroundImage'].value === '') {
						optionsPanelItem.backgroundImage = '';
						optionsPanelItem.backgroundImageDesc = '';
					}
				} else if (optionsPanelMode === 'itemRef') {
					angular.forEach($scope.data.itemRefOptions, function(itemRefOption) {
						if ((angular.isDefined(itemRefOption.lookup))
							&& (angular.isDefined($scope.data.itemRefList))
							&& (angular.isDefined($scope.viewModel.optionLookup[optionsPanelItem.name]))
							&& (angular.isDefined($scope.viewModel.optionLookup[optionsPanelItem.name][itemRefOption.name]))) {
							if (($scope.viewModel.optionLookup[optionsPanelItem.name][itemRefOption.name].value === '')
								&& (angular.isDefined($scope.data.itemRefList.itemRefs[optionsPanelItem.name]))
								&& ($scope.data.itemRefList.itemRefs[optionsPanelItem.name][itemRefOption.name])) {
								$scope.data.itemRefList.itemRefs[optionsPanelItem.name][itemRefOption.name] = '';
							}
							// Lookup options should also allow free text
							if (!$scope.viewModel.optionLookup[optionsPanelItem.name][itemRefOption.name].lookupValueSelected) {
								if (angular.isUndefined($scope.data.itemRefList.itemRefs[optionsPanelItem.name])) {
									$scope.data.itemRefList.itemRefs[optionsPanelItem.name] = {};
								}
								$scope.data.itemRefList.itemRefs[optionsPanelItem.name][itemRefOption.name] =
								$scope.viewModel.optionLookup[optionsPanelItem.name][itemRefOption.name].value;
							}
						}
					});
				} else if (optionsPanelMode === 'tableItemRef') {
					angular.forEach($scope.data.tableItemRefOptions, function(tableItemRefOption) {
						if ((angular.isDefined(tableItemRefOption.lookup))
							&& (angular.isDefined($scope.data.itemRefList))
							&& (angular.isDefined($scope.viewModel.optionLookup[optionsPanelItem.name]))
							&& (angular.isDefined($scope.viewModel.optionLookup[optionsPanelItem.name][tableItemRefOption.name]))) {
							if (($scope.viewModel.optionLookup[optionsPanelItem.name][tableItemRefOption.name].value === '')
								&& (angular.isDefined($scope.data.itemRefList.tableItemRefs[optionsPanelItem.name]))
								&& ($scope.data.itemRefList.tableItemRefs[optionsPanelItem.name][tableItemRefOption.name])) {
								$scope.data.itemRefList.tableItemRefs[optionsPanelItem.name][tableItemRefOption.name] = '';
							}
							if (!$scope.viewModel.optionLookup[optionsPanelItem.name][tableItemRefOption.name].lookupValueSelected) {
								if (angular.isUndefined($scope.data.itemRefList.tableItemRefs[optionsPanelItem.name])) {
									$scope.data.itemRefList.tableItemRefs[optionsPanelItem.name] = {};
								}
								$scope.data.itemRefList.tableItemRefs[optionsPanelItem.name][tableItemRefOption.name] =
								$scope.viewModel.optionLookup[optionsPanelItem.name][tableItemRefOption.name].value;
							}
						}
					});
				}
			}
		};
		$mdPanel.open(panelConfig);
		$event.stopPropagation();
	};

	var layoutEditImportContextCtrl = function(mdPanelRef, $scope, $log, data, viewModel, importLayout) {
		$scope.data = data;
		$scope.viewModel = viewModel;
		
		$scope.importLayoutThenClose = function(importContext) {
			importLayout(importContext);
			mdPanelRef.close();
		};
	};

	$scope.openImportContextPanel = function($event) {
		$scope.clearSelected();
		
		var panelPosition = $mdPanel.newPanelPosition().absolute().center();
		var panelConfig = {
			controller: layoutEditImportContextCtrl,
			controllerAs: 'ctrl',
			bindToController: false,
			position: panelPosition,
			targetEvent: $event,
			templateUrl: 'template/layoutEdit/importContextPanel/importContextPanel.html',
			clickOutsideToClose: true,
			escapeToClose: true,
			focusOnOpen: true,
			trapFocus: true,
			hasBackdrop: true,
			locals: {
				data: $scope.data,
				viewModel: $scope.viewModel,
				importLayout: $scope.importLayout
			}
		};
		$mdPanel.open(panelConfig);
		$event.stopPropagation();
	};
	
	var layoutEditTranslationsForCtrl = function(mdPanelRef, $scope, data, viewModel, updateTranslations) {
		$scope.data = data;
		$scope.viewModel = viewModel;
		
		$scope.updateTranslationsThenClose = function(contextCode, contextDescription) {
			updateTranslations(data.component.id, contextCode, contextDescription);
			mdPanelRef.close();
		};
	};
	
	$scope.openTranslationsForPanel = function($event) {
		$scope.clearSelected();
		
		var panelPosition = $mdPanel.newPanelPosition().absolute().center();
		var panelConfig = {
			controller: layoutEditTranslationsForCtrl,
			controllerAs: 'ctrl',
			bindToController: false,
			position: panelPosition,
			targetEvent: $event,
			templateUrl: 'template/layoutEdit/translationsForPanel/translationsForPanel.html',
			clickOutsideToClose: true,
			escapeToClose: true,
			focusOnOpen: true,
			trapFocus: true,
			hasBackdrop: true,
			locals: {
				data: $scope.data,
				viewModel: $scope.viewModel,
				updateTranslations: $scope.updateTranslations
			}
		};
		$mdPanel.open(panelConfig);
		$event.stopPropagation();
	};

	$scope.addDefaultLayout = function() {
		if ($scope.data.component.items) {
			$scope.data.layout = {
				'sections': $scope.layoutElements.section
			};
		}
		if (angular.isDefined($scope.data.component.tableItems)) {
			delete $scope.data.list;
			$scope.addDefaultList();
		} else {
			// For lists, this is done in 'addDefaultList'
			$scope.addToUndoStack();
		}
	};

	$scope.addDefaultList = function() {
		var maxNoColumns = 15;
		if ($scope.data.list) return false;
		if (!$scope.data.component.tableItems) return false;

		if ((!$scope.data.layout) || (!$scope.data.layout.sections)) {
			$scope.data.layout = {
				'sections': [
				{list: true}
				]
			};
		} else {
			// Add a list section if one doesn't exist already
			if (!$scope.data.layout.sections.some(function(section) { return section.list; })) {
				$scope.data.layout.sections = $scope.data.layout.sections.concat([{list: true}]);
			}
		}

		$scope.data.list = {};
		$scope.data.list.columns = [];
		var newColumn;
		for (var i = 0; i < $scope.data.component.tableItems.length && i < maxNoColumns; i++) {
			var tableItem = $scope.data.component.tableItems[i];
			if (tableItem.dynamicColumn) {
				newColumn = {'dynamicColumn': tableItem.name};
			} else {
				newColumn = {'columnRows': [{'tableItemRefs': [$scope.data.component.tableItems[i]]}]};
			}
			$scope.data.list.columns = $scope.data.list.columns.concat(newColumn);
		}
		if ($scope.data.component.tableItems.length > maxNoColumns) {
			var message = 'Warning: This table contains over ' + maxNoColumns
				+ ' columns. Add additional columns from "Table Items"';
			ToastService.show({
				message: message
			});
		}
		$scope.addToUndoStack();
		$scope.refreshToolboxItems();
	};
	
	// Saves the current layout state into the undo stack
	$scope.addToUndoStack = function() {
		var undoStackElement = '';
		
		// Clear anything in the stack from the current index onwards
		for (var i = ($scope.viewModel.undoStack.length - 1); i > $scope.viewModel.undoStackIndex; i--) {
			$scope.viewModel.undoStack.pop();
		}
		$scope.viewModel.undoStackIndex++;
		$scope.viewModel.undoStack[$scope.viewModel.undoStackIndex] = {};
		
		// Only save certain elements from $scope.data
		for (i = 0; i < $scope.viewModel.undoStackElements.length; i++) {
			undoStackElement = $scope.viewModel.undoStackElements[i];
			
			$scope.viewModel.undoStack[$scope.viewModel.undoStackIndex][undoStackElement] = {};
			angular.copy(
				$scope.data[undoStackElement],
				$scope.viewModel.undoStack[$scope.viewModel.undoStackIndex][undoStackElement]
			);
		}
	};
	$scope.addToUndoStack();
	
	// Restores the layout elements from the current index of the undo stack
	$scope.applyUndoStack = function() {
		var undoStackElement = '';
		for (var i = 0; i < $scope.viewModel.undoStackElements.length; i++) {
			undoStackElement = $scope.viewModel.undoStackElements[i];
			
			$scope.data[undoStackElement] = {};
			angular.copy(
				$scope.viewModel.undoStack[$scope.viewModel.undoStackIndex][undoStackElement],
				$scope.data[undoStackElement]
			);
		}
	};
	
	// Changes the state of the layout to the previous state in the undo stack
	$scope.undo = function() {
		if ($scope.viewModel.undoStackIndex === 0) return;
		
		$scope.clearSelected();
		$scope.viewModel.undoStackIndex--;
		$scope.applyUndoStack();
		$scope.refreshToolboxItems();
	};
	
	// Changes the state of the layout to the next state in the undo stack
	$scope.redo = function() {
		if ($scope.viewModel.undoStackIndex === ($scope.viewModel.undoStack.length - 1)) return;
		
		$scope.clearSelected();
		$scope.viewModel.undoStackIndex++;
		$scope.applyUndoStack();
		$scope.refreshToolboxItems();
	};
	
	// Resets the currently selected item and hides the hover
	$scope.clearSelected = function() {
		if (($scope.state.selected.array) &&
			($scope.state.selected.array[$scope.state.selected.index])) {
			$scope.state.selected.array[$scope.state.selected.index].selected = false;
		}
		$scope.state.selected = {};
		$scope.toggleOptionsHover();
	};

	$scope.syntaxHighlight = function(json) {
		json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		var regex = /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g;
		return json.replace(regex,
			function(match) {
			var cls = 'number';
			if (/^"/.test(match)) {
				if (/:$/.test(match)) {
					cls = 'key';
				} else {
					cls = 'string';
				}
			} else if (/true|false/.test(match)) {
				cls = 'boolean';
			} else if (/null/.test(match)) {
				cls = 'null';
			}
			return '<span class="' + cls + '">' + match + '</span>';
		});
	};
	
	// Toggles a visible element
	$scope.toggleElement = function(element) {
		$scope.viewModel.toggles[element] = !$scope.viewModel.toggles[element];
		$scope.clearSelected();
		$scope.toggleOptionsHover();
	};
	
	// Returns the total weight for all blocks in a container (e.g. section)
	$scope.getBlockTotalWeight = function(container) {
		var totalWeight = 0;
		angular.forEach(container.blocks, function(block) {
			totalWeight += ((Number(block.weight) > 1) ? Number(block.weight) : 1);
		});
		return totalWeight;
	};
	
	// Returns the percentage value for a Block weight
	// Note: Changes to this logic should be also made in system.UI.Material.LayoutBlockBegin()
	$scope.getBlockPercentageWeight = function(blockWeight, container) {
		if ((!blockWeight) || (blockWeight === '')) return '';
		blockWeight = Number(blockWeight);
		if (isNaN(blockWeight) || (blockWeight < 2)) return '';
		
		var totalWeight = $scope.getBlockTotalWeight(container);
		blockWeight = Math.round((blockWeight / totalWeight) * 100);
		// Angular Material accepts percentage widths of 33, 66 or multiples of 5
		if ((blockWeight > 65) && (blockWeight < 70)) {
			blockWeight = 66;
		} else if ((blockWeight > 30) && (blockWeight < 35)) {
			blockWeight = 33;
		} else {
			// Round up to the nearest multiple of 5
			blockWeight = (Math.floor(blockWeight / 5) * 5);
			if (blockWeight == 0) blockWeight = 5;
		}
		return blockWeight;
	};
	
	var openNewOptionsPanel = function($event, optionsPanelMode, optionsPanelItem) {
		$scope.viewModel.panelOpening = true;
		var optionsParams = ('&ComponentName=' + encodeURIComponent($scope.data.component.name));
		var elementType = '';
		if (['itemRef','button','tableItemRef'].indexOf(optionsPanelMode) !== -1) {
			if (angular.isDefined(optionsPanelItem.Type)) {
				optionsPanelMode = 'layoutItemRef';
				elementType = optionsPanelItem.Type;
			} else {
				optionsParams += ('&ComponentItemName=' + encodeURIComponent(optionsPanelItem.name));
			}
			// Chart items do not have any options
			if (optionsPanelItem.displayType === 'CHART') optionsParams += '&tkDisabled=1';
		} else if (optionsPanelMode !== 'component') {
			elementType = optionsPanelMode.substr(0, 1).toUpperCase() + optionsPanelMode.substr(1);
		}
		
		// Pass the values for option conditions
		if ((!$scope.viewModel.advancedExpressions)
			&& ((elementType !== '') 
				|| (['itemRef','button','tableItemRef','layoutItemRef'].indexOf(optionsPanelMode) !== -1))
			&& angular.isObject(optionsPanelItem)) {
			var optionValues = $scope.getOptionValues(optionsPanelMode, optionsPanelItem.name);
			angular.forEach(optionValues, function(option) {
				if ((angular.isObject(option.value)) && (angular.isDefined(option.value.condition))) {
					var optionName = option.name.split('Condition')[0];
					if (optionName === '') return;
					
					optionsParams += ('&' + optionName + '_ValueConditionCode=' + option.value.condition);
					if ((angular.isDefined(option.value.fieldName)) && (option.value.fieldName !== '')) {
						optionsParams += ('&' + optionName + '_ConditionFieldName='
										+ encodeURIComponent(option.value.fieldName));
						var optionFieldCaption = $scope.data.translations[option.value.fieldName];
						if ((angular.isUndefined(optionFieldCaption)) || (optionFieldCaption === '')) {
							optionFieldCaption = option.value.fieldName;
						}
						optionsParams += ('&' + optionName + '_ConditionField=' + encodeURIComponent(optionFieldCaption));
					}
					if ((angular.isDefined(option.value.operator)) && (option.value.operator !== '')) {
						optionsParams += ('&' + optionName + '_ConditionOperatorCode='
										+ encodeURIComponent(option.value.operator));
						if ((angular.isDefined(option.value.value)) && (option.value.value !== '')) {
							if (option.value.operator === 'L') {
								optionsParams += ('&' + optionName + '_ConditionValueInList='
												+ encodeURIComponent(option.value.value));
							} else {
								optionsParams += ('&' + optionName + '_ConditionValue='
												+ encodeURIComponent(option.value.value));
							}
						}
					}
				}
			});
		}
		
		if (elementType !== '') optionsParams += ('&ElementType=' + elementType);
		optionsParams += ('&OptionPanelMode=' + optionsPanelMode);
		optionsParams += ('&AdvancedExpressions=' + ($scope.viewModel.advancedExpressions ? '1' : '0'));
		if ((optionsPanelMode === 'section') && (optionsPanelItem.list)) {
			// List sections do not have any options
			optionsParams += '&tkDisabled=1';
		} else if ($scope.viewModel.isReadOnly) {
			optionsParams += '&ReadOnly=1';
		}
		if ((angular.isDefined($scope.viewModel.selectedContext))
			&& ($scope.viewModel.selectedContext.desc !== '')) {
			optionsParams += ('&ViewContext=' + encodeURIComponent($scope.viewModel.selectedContext.id));
		}
		if ((elementType === 'Column') && (angular.isDefined(optionsPanelItem.dynamicColumn))) {
			optionsParams += '&DynamicColumn=1';
		}
		
		var applyOptions = function() {
			$timeout(function() {
				GlobalService.callFunction('system_LayoutEditor_Options_0', 'ApplyOptions');
			}, 200);
		};
		
		var openComplete = function() {
			// Prevent opening multiple panels at the same time
			$scope.viewModel.panelOpening = false;
		};
		
		OverlayService.open({
			event: $event,
			componentName: 'system.LayoutEditor.Options',
			params: optionsParams,
			onRemovingHandler: applyOptions,
			onOpenCompleteHandler: openComplete
		});
	};
	
	// Returns the component translations for use in system.LayoutEditor.Options component
	$scope.getTranslations = function() {
		return $scope.data.translations;
	};
	
	// Returns the option values for use in system.LayoutEditor.Options component
	$scope.getOptionValues = function(optionPanelMode, componentItemName) {
		var optionArray = [];
		if (optionPanelMode === 'component') {
			if (angular.isDefined($scope.data.componentOptions)) return $scope.data.componentOptions;
		} else if ((optionPanelMode === 'itemRef') || (optionPanelMode === 'button')) {
			if ((angular.isDefined($scope.data.itemRefList)) && (angular.isDefined($scope.data.itemRefList.itemRefs))) {
				angular.forEach($scope.data.itemRefList.itemRefs[componentItemName], function(optionValue, optionName) {
					optionArray.push({name: optionName, value: optionValue});
				});
			}
		} else if (optionPanelMode === 'tableItemRef') {
			if ((angular.isDefined($scope.data.itemRefList)) && (angular.isDefined($scope.data.itemRefList.tableItemRefs))) {
				angular.forEach($scope.data.itemRefList.tableItemRefs[componentItemName], function(optionValue, optionName) {
					optionArray.push({name: optionName, value: optionValue});
				});
			}
		} else if (optionPanelMode === 'extraDetails') {
			if (angular.isDefined($scope.data.extraDetails)) {
				optionArray.push({name: 'Description', value: $scope.data.extraDetails.description});
			}
		} else if (angular.isDefined($scope.viewModel.optionsPanelItem)) {
			angular.forEach($scope.viewModel.optionsPanelItem, function(optionValue, optionName) {
				if (optionName.substr(0, 2) === '$$') return;
				
				optionArray.push({name: (optionName.substr(0, 1).toUpperCase() + optionName.substr(1)), value: optionValue});
			});
		}
		
		return optionArray;
	};
	
	// Sets the option values when system.LayoutEditor.Options component is closed
	$scope.setOptionValues = function(optionPanelMode, componentItemName, options) {
		if (optionPanelMode === 'component') {
			angular.forEach($scope.data.componentOptions, function(compOption, compOptionIndex, compOptionArray) {
				if (angular.isUndefined(compOption.name)) return;
				if (angular.isUndefined(options[compOption.name])) return;
				
				compOptionArray[compOptionIndex].value = options[compOption.name];
			});
		} else {
			angular.forEach(options, function(optionValue, optionName) {
				if (angular.isUndefined(optionValue)) return;
				
				if ((optionPanelMode === 'itemRef') || (optionPanelMode === 'button')) {
					if (angular.isUndefined($scope.data.itemRefList)) $scope.data.itemRefList = {};
					if (angular.isUndefined($scope.data.itemRefList.itemRefs)) $scope.data.itemRefList.itemRefs = {};
					if (angular.isUndefined($scope.data.itemRefList.itemRefs[componentItemName])) {
						$scope.data.itemRefList.itemRefs[componentItemName] = {};
					}
					$scope.data.itemRefList.itemRefs[componentItemName][optionName] = optionValue;
					if ((optionValue === '')
						&& (angular.isDefined($scope.data.itemRefList.itemRefs[componentItemName][optionName + 'Condition']))) {
						delete $scope.data.itemRefList.itemRefs[componentItemName][optionName + 'Condition'];
					}
				} else if (optionPanelMode === 'tableItemRef') {
					if (angular.isUndefined($scope.data.itemRefList)) $scope.data.itemRefList = {};
					if (angular.isUndefined($scope.data.itemRefList.tableItemRefs)) $scope.data.itemRefList.tableItemRefs = {};
					if (angular.isUndefined($scope.data.itemRefList.tableItemRefs[componentItemName])) {
						$scope.data.itemRefList.tableItemRefs[componentItemName] = {};
					}
					$scope.data.itemRefList.tableItemRefs[componentItemName][optionName] = optionValue;
					if ((optionValue === '')
						&& (angular.isDefined($scope.data.itemRefList.tableItemRefs[componentItemName][optionName + 'Condition']))) {
						delete $scope.data.itemRefList.tableItemRefs[componentItemName][optionName + 'Condition'];
					}
				} else if (optionPanelMode === 'extraDetails') {
					if (angular.isUndefined($scope.data.extraDetails)) $scope.data.extraDetails = {};
					if (optionName === 'Description') $scope.data.extraDetails.description = optionValue;
				} else if (angular.isDefined($scope.viewModel.optionsPanelItem)) {
					if (optionPanelMode !== 'layoutItemRef') {
						optionName = (optionName.substr(0, 1).toLowerCase() + optionName.substr(1));
					}
					if (optionValue === '') {
						delete $scope.viewModel.optionsPanelItem[optionName];
						if (angular.isDefined($scope.viewModel.optionsPanelItem[optionName + 'Condition'])) {
							delete $scope.viewModel.optionsPanelItem[optionName + 'Condition'];
						}
					} else {
						// Only allow one column to set this option
						if ((optionName === 'allowToCopyClinicalData') && (optionValue === true)) {
							angular.forEach($scope.data.list.columns, function(column) {
								delete column.allowToCopyClinicalData;
							});
						}
						$scope.viewModel.optionsPanelItem[optionName] = optionValue;
					}
				}
			});
		}
	};
	
	// Returns true if an item should be highlighted
	var highlightLayoutItem = function(itemName, searchString) {
		if (searchString === '') return false;
		if (angular.isUndefined(itemName)) return false;
		
		if (itemName.toUpperCase().indexOf(searchString) !== -1) return true;
		if ((angular.isDefined($scope.data.translations[itemName]))
			&& ($scope.data.translations[itemName].toUpperCase().indexOf(searchString) !== -1)) return true;
		return false;
	};
	
	// Traverses nested blocks to highlight items
	var highlightInBlock = function(block, searchString) {
		if (angular.isDefined(block.room)) {
			block.highlighted = highlightLayoutItem('Room' + block.room, searchString);
		}
		angular.forEach(block.rows, function(row) {
			if (angular.isDefined(row.blocks) && (row.blocks.length)) {
				angular.forEach(row.blocks, function(nestedBlock) {
					highlightInBlock(nestedBlock, searchString);
				});
			} else {
				angular.forEach(row.itemRefs, function(itemRef) {
					if (itemRef.name !== '') {
						itemRef.highlighted = highlightLayoutItem(itemRef.name, searchString);
					} else if (angular.isDefined(itemRef.FreeText)) {
						itemRef.highlighted = highlightLayoutItem(itemRef.FreeText, searchString);
					} else if (angular.isDefined(itemRef.FreeTextMultiLine)) {
						itemRef.highlighted = highlightLayoutItem(itemRef.FreeTextMultiLine, searchString);
					}
				});
			}
		});
		return;
	};
	
	// Sets or clears highlighting on items based on toolbox search
	$scope.highlightLayoutItems = function() {
		var searchString = ($scope.viewModel.searchToolbox ? $scope.viewModel.searchToolbox.toUpperCase() : '');
		
		if (($scope.data.layout) && ($scope.data.layout.sections)) {
			angular.forEach($scope.data.layout.sections, function(section) {
				angular.forEach(section.blocks, function(block) {
					highlightInBlock(block, searchString);
				});
			});
		}
		if (($scope.data.list) && ($scope.data.list.columns)) {
			angular.forEach($scope.data.list.columns, function(column) {
				if (angular.isDefined(column.dynamicColumn)) {
					column.highlighted = highlightLayoutItem(column.dynamicColumn, searchString);
				} else {
					angular.forEach(column.columnRows, function(columnRow) {
						angular.forEach(columnRow.tableItemRefs, function(tableItemRef) {
							tableItemRef.highlighted = highlightLayoutItem(tableItemRef.name, searchString);
						});
					});
				}
			});
		}
		if (($scope.data.buttonBar) && ($scope.data.buttonBar.buttons)) {
			angular.forEach($scope.data.buttonBar.buttons, function(button) {
				button.highlighted = highlightLayoutItem(button.name, searchString);
			});
		}
		if (($scope.data.headerBar) && ($scope.data.headerBar.items)) {
			angular.forEach($scope.data.headerBar.items, function(headerBarItem) {
				headerBarItem.highlighted = highlightLayoutItem(headerBarItem.name, searchString);
			});
		}
		if ($scope.data.actionMenu) {
			angular.forEach($scope.data.actionMenu.headers, function(actionMenuHeader) {
				actionMenuHeader.highlighted = highlightLayoutItem(actionMenuHeader.name, searchString);
			});
			angular.forEach($scope.data.actionMenu.links, function(actionMenuLink) {
				actionMenuLink.highlighted = highlightLayoutItem(actionMenuLink.name, searchString);
			});
			angular.forEach($scope.data.actionMenu.items, function(actionMenuItem) {
				actionMenuItem.highlighted = highlightLayoutItem(actionMenuItem.name, searchString);
			});
		}
	};
	
	$scope.$on('Global:callFunction', function(event, componentHtmlName, 
		functionName, args, callbackFunction) {
		if (componentHtmlName !== 'LayoutEditor') return;
	
		if (angular.isFunction($scope[functionName])) {
			var returnValue = $scope[functionName].apply(this, args);
			if (angular.isFunction(callbackFunction)) callbackFunction(returnValue);
		} else {
			$log.warn('Could not find function ', functionName, ' in ', componentHtmlName, ' controller');
		}
	});

})
.filter('filterItemOptions', function() {
	return function(itemOptions, optionsPanelItem, componentName) {
		return itemOptions.filter(function(itemOption) {
			// Only allow limited options for lookup columns
			if (optionsPanelItem.displayType === 'LOOKUPCOLUMN') {
				if (['Delimiter','ResponsiveDisplay','DisplayStyle'].indexOf(itemOption.name) !== -1) {
					return true;
				} else {
					return false;
				}
			}
			// Only allow limited options for data setup items
			if (optionsPanelItem.displayType === 'DSI') {
				// Special case for icon profiles
				if (optionsPanelItem.name.indexOf('DSI_IP') === 0) {
					return (itemOption.name === 'IconProfileCode');
				}
				if (['Delimiter','DisplayStyle'].indexOf(itemOption.name) !== -1) {
					return true;
				} else {
					return false;
				}
			}
			// Filter options for Floorplan items
			if (['FPBED','FPRESOURCE'].indexOf(optionsPanelItem.displayType) !== -1) {
				return false;
			}
			if (itemOption.validItemTypes) {
				var validItemTypes = (',' + itemOption.validItemTypes + ',');
				if (validItemTypes.indexOf((',' + optionsPanelItem.displayType + ',')) == -1) {
					return false;
				}
			}
			if (itemOption.validDataTypes) {
				var validDataTypes = (',' + itemOption.validDataTypes + ',');
				if (validDataTypes.indexOf((',' + optionsPanelItem.dataType + ',')) == -1) {
					return false;
				}
			}
			if ((itemOption.name === 'DisableDynamicFavourites') && (!optionsPanelItem.dynamicFavourites)) {
				return false;
			}
			if ((angular.isDefined(componentName))
				&& (['CustomLookupClassName','CustomLookupQueryName','CustomLookupProperties'].indexOf(itemOption.name) !== -1)
				&& (componentName !== 'webcommon.Report.Custom')) {
				return false;
			}
			
			return true;
		});
	};
})
.filter('filterElementOptions', function() {
	return function(elementOptions, optionsPanelMode, isDataSetup, optionsPanelItem) {
		return elementOptions.filter(function(elementOption) {
			// Only allow item alignment for data setup layouts
			if ((optionsPanelMode === 'row') && (elementOption.name === 'ItemAlignment')) {
				return (isDataSetup === true);
			}
			// ColumnClass is only set in Column options for dynamic columns
			if ((optionsPanelMode === 'column') && (angular.isUndefined(optionsPanelItem.dynamicColumn))
				&& (elementOption.name === 'DynamicColumnClass')) {
				return false;
			}
			return true;
		});
	};
})
.filter('keyboardShortcut', function($window) {
	return function(str) {
		if (!str) return;
		var keys = str.split('-');
		var isOSX = /Mac OS X/.test($window.navigator.userAgent);
		var seperator = (!isOSX || keys.length > 2) ? '+' : '';
		var abbreviations = {
			C: isOSX ? '?' : 'Ctrl',
			A: isOSX ? 'Option' : 'Alt',
			S: 'Shift'
		};
		return keys.map(function(key, index) {
			var last = index == keys.length - 1;
			return last ? key : abbreviations[key];
		}).join(seperator);
	};
})
.filter('itemHasExpressionOrCondition', function() {
	return function(itemRef) {
		if (angular.isUndefined(itemRef)) return false;
		
		// Show an indicator if the field has any AngularJS expression or condition other than true, false or blank
		// Note: lowercase 'hidden' property is defined for columns
		var excludedExpressions = ['', true, false, 'true', 'false'];
		if (((angular.isDefined(itemRef.Disabled)) && (excludedExpressions.indexOf(itemRef.Disabled) === -1))
			|| ((angular.isDefined(itemRef.Hidden)) && (excludedExpressions.indexOf(itemRef.Hidden) === -1))
			|| ((angular.isDefined(itemRef.ReadOnly)) && (excludedExpressions.indexOf(itemRef.ReadOnly) === -1))
			|| ((angular.isDefined(itemRef.Required)) && (excludedExpressions.indexOf(itemRef.Required) === -1))
			|| ((angular.isDefined(itemRef.hidden)) && (excludedExpressions.indexOf(itemRef.hidden) === -1))
			|| ((angular.isDefined(itemRef.Bold)) && (excludedExpressions.indexOf(itemRef.Bold) === -1))) {
			return true;
		}
				
		return false;
	};
});
